import React, { Suspense } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ScrollToTop from './components/ScrollToTop'
import Loading from './components/Loading'
import AppRoutes from './AppRoutes'

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Suspense fallback={<Loading />}>
            <AppRoutes />
          </Suspense>
        </Router>
      </AuthProvider>
    </div>
  )
}

export default App

